import { get, keyBy } from 'lodash/fp';
import { createReducer } from '@mews-framework/redux';
import { CULTURE_INFO_FETCH_SUCCEEDED, GLOBALIZATION_FETCH_SUCCEEDED, TEXTS_FETCH_SUCCEEDED } from './actionTypes';

const INITIAL_STATE = {};

export const reducer = createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [GLOBALIZATION_FETCH_SUCCEEDED]: (state, { languages, ...otherProps }: $TSFixMe) => ({
        ...state,
        ...otherProps,

        languages: {
            ...get('languages', state),
            ...keyBy('code', languages),
        },
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [TEXTS_FETCH_SUCCEEDED]: (state, { languageCode, texts }: $TSFixMe) => ({
        ...state,
        texts: { ...state.texts, [languageCode]: texts },
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [CULTURE_INFO_FETCH_SUCCEEDED]: (state, { cultureCode, ...info }: $TSFixMe) => ({
        ...state,
        cultureInfos: { ...state.cultureInfos, [cultureCode]: { code: cultureCode, ...info } },
    }),
});
